import React, { FC } from 'react';
import { memberPortalRouteItems } from 'constants/routeItems/routeItemMemberPortal.constants';
import SidebarRoutes from 'components/Sidebar/SidebarRoutes';

const MemberPortalSidebarRoutes: FC = () => {
  return <SidebarRoutes routeItems={memberPortalRouteItems} />;
};

export default MemberPortalSidebarRoutes;
